/*
*
* File JS componente Block Cube
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-cube.scss';

//--------------------------------------------------------------------//

// JS COMPONENTE
//--------------------------------------------------------------------//

let controller = new ScrollMagic.Controller();
const elBlockCube = document.querySelector('.block-cube');

const manageHeightPositions = () => {
    
    const blockCubeScene = elBlockCube.querySelector('.block-cube__scene');
    const allCubeAreas = elBlockCube.querySelectorAll('.block-cube__scene-area');
    const elCube = elBlockCube.querySelector('.block-cube__scene-cube');
    const allCubeLines = elBlockCube.querySelectorAll('.block-cube__scene-cube-line');

    let innerArea1 = allCubeAreas[0];
    let innerArea2 = allCubeAreas[1];
    let innerArea3 = allCubeAreas[2];


    if (window.innerWidth > 1024)
    {
        if(allCubeLines.length){
            innerArea1.style.top = (percentage(elCube.offsetHeight, 7) + 30) + 'px';
            innerArea2.style.top = (percentage(elCube.offsetHeight, 50) + 30) + 'px';
            innerArea3.style.top = (elCube.offsetHeight + 85) + 'px';

            blockCubeScene.style.height = ((innerArea3.offsetHeight + elCube.offsetHeight) + 100) + 'px'; 

            // allCubeLines[2].style.height = (blockCubeScene.offsetHeight - elCube.offsetHeight + percentage(elCube.offsetHeight, 10)) + 'px';
        }else{
            //Per settare l'altezza della scena in homepage
            blockCubeScene.style.height = ((innerArea2.offsetHeight + innerArea3.offsetHeight) + 50 )+ 'px'; 
            innerArea3.style.top = (innerArea1.offsetHeight + 85) + 'px'; 
        }
    }
    else
    {
        innerArea1.style.removeProperty('top');
        innerArea2.style.removeProperty('top');
        innerArea3.style.removeProperty('top');
        blockCubeScene.style.removeProperty('height');
        if(allCubeLines.length){
            allCubeLines[2].style.removeProperty('height');
        }
    }

}

const percentage = (num, per) => {
  return (num/100)*per;
}

const manageMobileAnimations = () => {

    const allCubeAreas = elBlockCube.querySelectorAll('.block-cube__scene-area');
    const mobileCube = elBlockCube.querySelector('.block-cube__scene-cube-mobile img');
    let mobileScene = [];

    if (window.innerWidth < 1025)
    {
        allCubeAreas.forEach((el, i) => {
            mobileScene[i] = new ScrollMagic.Scene({
                triggerElement: el,
                offset: 0,
                triggerHook: 0.1,
                duration: el.offsetHeight
            })
            // .addIndicators()
            .on('progress', (evt) => {
                switch (i) {
                    case 0:
                        let value0 = 60 + percentage(120, (evt.progress * 100));
                        mobileCube.style.transform = 'rotate('+ value0 +'deg)';
                        break;
                    case 1:
                        let value1 = 180 + percentage(120, (evt.progress * 100));
                        mobileCube.style.transform = 'rotate('+ value1 +'deg)';
                        break;
                
                    default:
                        break;
                }
            })
            .setClassToggle(el, 'animate')
            .addTo(controller);
        });
        
        console.log(mobileScene);
    }
}

const manageDeskAnimation = () => {

    let deskScene = null;

    deskScene = new ScrollMagic.Scene({
        triggerElement: elBlockCube,
        offset: 0,
        triggerHook: 0.5,
        reverse: false,
    })
    // .addIndicators()
    .setClassToggle(elBlockCube, 'animate')
    .addTo(controller);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockCube = () => {

    if (!elBlockCube) return;

    manageHeightPositions();

    manageMobileAnimations();

    manageDeskAnimation();

    window.addEventListener('resize', () => {
        manageHeightPositions();
    });
}

export default blockCube;

//--------------------------------------------------------------------//